import React, { useState } from "react";
import DiscordIcon from '../../assets/img/discord.png';
import TelegramIcon from '../../assets/img/telegram.png';
import TwitterIcon from '../../assets/img/twitter.png';
import DexscreenerIcon from '../../assets/img/dexscreener.png';
import DocsIcon from '../../assets/img/docs-img.png';
import styled from "styled-components";

interface FooterProps {
  children?: React.ReactNode;
}

const SocialLink = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 10px;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const Footer: React.FC<FooterProps> = ({ children }) => {
  return (
    <div className="mt-auto py-4 text-gray-400 text-sm px-2">
      <div className="flex justify-between items-center relative">
        <p className="flex-shrink-0">©Milkit {/* */}2025</p>
        <div className="text-gray-400 text-center text-sm" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <SocialLink onClick={() => window.open("https://docs.milkit.finance")} src={DocsIcon} alt="Docs" className="text-gray-400" />
          <SocialLink onClick={() => window.open("https://dexscreener.com/sonic/0x80797a61d219EAa4337eDCb1D44A54750bDADC9E")} src={DexscreenerIcon} alt="Telegram" className="text-gray-400" />
          <SocialLink onClick={() => window.open("https://t.me/MilkItFinance")} src={TelegramIcon} alt="Telegram" className="text-gray-400" />
          <SocialLink onClick={() => window.open("https://x.com/MilkItFinance")} src={TwitterIcon} alt="Twitter" className="text-gray-400" />
          <SocialLink onClick={() => window.open("https://discord.gg/8n9trt7Ear")} src={DiscordIcon} alt="Discord" className="text-gray-400" />
        </div>
      </div>
    </div>
  );
};

export default Footer;